import { Anchor } from "@atlassiansox/bxp-content-framework";

import { useAnalytics } from "../../components";
import { UiLinkBlockModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

import { LinkBlock } from "./UiLinkBlock.styles";

export type UiLinkBlockProps = {
    model: UiLinkBlockModel;
};

const UiLinkBlock = ({ model }: UiLinkBlockProps) => {
    const { sendTrackEvent } = useAnalytics();
    const { entryTitle, block, lift, lighten, title, url } = model.content;

    return (
        <LinkBlock data-testid="ui-link-block" lift={lift} lighten={lighten}>
            <Anchor
                aria-label={title}
                data-uuid={model.id}
                href={url}
                onClick={() =>
                    sendTrackEvent("clickedUiLinkBlock", {
                        event: "clicked",
                        eventComponent: "linkBlock",
                        eventContainer: "content",
                        href: url,
                        label: title,
                        labelEnglish: entryTitle,
                        uuid: model.id
                    })
                }
            >
                {renderViewModel(block)}
            </Anchor>
        </LinkBlock>
    );
};

export default UiLinkBlock;
